export class Client {
  id: number;
  name: string;
  email: string;
  user: string;
}
